const font_awesome_icon_classes_by_mime_type = {
    // Images
    'image': 'fa-file-image-o',
    // Audio
    'audio': 'fa-file-audio-o',
    // Video
    'video': 'fa-file-video-o',
    // Documents
    'application/pdf': 'fa-file-pdf-o',
    'text/plain': 'fa-file-text-o',
    'text/html': 'fa-file-code-o',
    'application/json': 'fa-file-code-o',
    // Archives
    'application/gzip': 'fa-file-archive-o',
    'application/zip': 'fa-file-archive-o',
    // Misc
	'application/octet-stream': 'fa-file-o',
};

const mapMimeTypeFontAwesomeActions = {
	font_awesome_file_icon_class (mimetype) {
		if (Object.keys(font_awesome_icon_classes_by_mime_type).includes(mimetype)) {
			return font_awesome_icon_classes_by_mime_type[mimetype];
		}

		let mime_parts = mimetype.split('/')
		if (Object.keys(font_awesome_icon_classes_by_mime_type).includes(mime_parts[0])) {
			return font_awesome_icon_classes_by_mime_type[mime_parts[0]];
		}

		return 'fa-file-o';
	}
}

export {
	font_awesome_icon_classes_by_mime_type,
	mapMimeTypeFontAwesomeActions
}
